import { createSelector } from '@ngrx/store';
import { workspaceFeature } from './workspace.reducer';
import {
  orgProjectsAdapter,
  orgUsersAdapter,
  organizationsAdapter,
  projectUsersAdapter,
  projectsAdapter,
} from './workspace.models';

const {
  selectProjects,
  selectOrganizations,
  selectOrgProjects,
  selectProjectUsers,
  selectOrgUsers,
  selectSelectedProjectId,
  selectSelectedOrganizationId,
  selectStatus,
  selectError,
} = workspaceFeature;

export {
  selectSelectedProjectId,
  selectSelectedOrganizationId,
  selectStatus,
  selectError,
};

export const selectAllProjects = createSelector(selectProjects, projectsAdapter.getSelectors().selectAll);
export const selectAllOrganizations = createSelector(selectOrganizations, organizationsAdapter.getSelectors().selectAll);
export const selectAllOrgProjects = createSelector(selectOrgProjects, orgProjectsAdapter.getSelectors().selectAll);
export const selectAllProjectUsers = createSelector(selectProjectUsers, projectUsersAdapter.getSelectors().selectAll);
export const selectAllOrgUsers = createSelector(selectOrgUsers, orgUsersAdapter.getSelectors().selectAll);

export const selectIsReady = createSelector(selectStatus, (status) => status === 'ready');
export const selectIsLoading = createSelector(selectStatus, (status) => status === 'loading');

export const selectActiveProjectId = createSelector(
  selectAllProjects,
  selectSelectedProjectId,
  (projects, selectedId) => {
    if (selectedId && projects.some((p) => p.id === selectedId)) return selectedId;
    return projects[0]?.id ?? null;
  }
);

export const selectActiveOrganizationId = createSelector(
  selectAllOrganizations,
  selectAllOrgProjects,
  selectSelectedOrganizationId,
  selectActiveProjectId,
  (orgs, orgProjects, selectedOrgId, activeProjectId) => {
    if (selectedOrgId && orgs.some((o) => o.id === selectedOrgId)) return selectedOrgId;
    if (!activeProjectId) return null;
    return orgProjects.find((op) => op.projectId === activeProjectId)?.organizationId ?? null;
  }
);

export const selectActiveProject = createSelector(
  selectAllProjects,
  selectActiveProjectId,
  (projects, id) => projects.find((p) => p.id === id) ?? null
);
